import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  LabelList,
} from "recharts";
import Card from "components/base/Card";
import DateRangeSlider from "components/base/DateRangeSlider";
import { useEffect, useState } from "react";

const ReportChart = ({
  title,
  subtitle,
  valueName,
  data,
  fillColor,
  width = "w-full",
  onClick,
  className,
}) => {
  const [dateRange, setDateRange] = useState([0, data.length - 1]);
  const [activeAnimation, setActiveAnimation] = useState(true);

  useEffect(() => {
    setDateRange([0, data.length - 1]);
  }, [data]);

  useEffect(() => {
    // Only animate the first time
    if (activeAnimation) {
      setTimeout(() => {
        setActiveAnimation(false);
      }, 500);
    }
  }, []);

  const filteredData = data.slice(dateRange[0], dateRange[1] + 1);

  return (
    <div className={`${width} ${className}`}>
      <Card
        className="border-0 dark:border-0"
        title={title}
        subtitle={subtitle}
      >
        <ResponsiveContainer width="100%" height={200}>
          <BarChart
            data={filteredData}
            stackOffset="silhouette"
            margin={{ top: 20, right: 0, bottom: 0, left: -30 }}
          >
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip cursor={{ fill: "#f5f5f5" }} />
            <Bar
              key={Date.now()}
              dataKey="value"
              maxBarSize={40}
              minBarSize={10}
              fill={fillColor}
              name={valueName}
              onClick={onClick ? onClick : null}
              className={onClick ? "cursor-pointer" : ""}
              isAnimationActive={activeAnimation}
            >
              <LabelList dataKey="value" position="top" />
            </Bar>
          </BarChart>
        </ResponsiveContainer>

        <DateRangeSlider
          key={data.length}
          min={0}
          max={data.length - 1}
          onChange={setDateRange}
        />
      </Card>
    </div>
  );
};

export default ReportChart;
